<template>
  <section>
    <div class>
      <div class="utab clearfix">
        <ul class="clearlist clearfix fl">
          <li :class="nowStatus==''?'active':''" @click="changeTab('')">
            <a href="javascript:;">所有订单</a>
          </li>
          <li :class="nowStatus=='0'?'active':''" @click="changeTab('0')">
            <a href="javascript:;">待付款</a>
          </li>
          <li :class="nowStatus==1?'active':''" @click="changeTab('1')">
            <a href="javascript:;">待发货</a>
          </li>
          <li :class="nowStatus==2?'active':''" @click="changeTab('2')">
            <a href="javascript:;">待收货</a>
          </li>
          <li :class="nowStatus==3?'active':''" @click="changeTab('3')">
            <a href="javascript:;">已完成</a>
          </li>
        </ul>
        <div class="usearch fr">
          <input type="text" placeholder="商品名称/订单号" class="layui-input" v-model="keyword" />
          <button type="primary" @click="search" class="layui-btn layui-btn-sm">搜索</button>
        </div>
      </div>
      <el-table :data="allOrder.data" border style="width: 95%; margin: 20px auto">
        <el-table-column label="订单信息" width="180">
          <template slot-scope="scope">
            <div class="text_l">
              <div>订单号:{{ scope.row.orderno }}</div>
              <br />
              <div>{{ scope.row.addtime }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="80"></el-table-column>
        <el-table-column prop="amount" label="实付款" width="100"></el-table-column>
        <el-table-column label="商品信息" width="300">
          <template slot-scope="scope">
            <div class>
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ scope.row.productid" target="_blank">
                    <img :src="scope.row.indexpic" />
                  </a>
                </div>
                <div class="cont">
                  <div class="name">{{scope.row.title}}</div>
                  <div class="info">{{scope.row.specnames}}</div>
                </div>
                <div class="cart-price">{{scope.row.price}}*{{scope.row.num}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态" width="100"></el-table-column>
        <!-- <el-table-column prop="amount3" label="操作">
          <template slot-scope="scope">
              <a href="javascript:;"  class="layui-btn layui-btn-primary layui-btn-sm mab10" @click="orderdetail(scope.row.orderno)">订单详情</a>
            <a
              v-if="scope.row.status==2"
              href="javascript:;"
              @click="confirmGoods(scope.row.orderno)"
              class="layui-btn layui-btn-primary layui-btn-sm"
            >确认收货</a>
            <a
              v-if="scope.row.expressno"
              href="javascript:;"
              @click="logistics(scope.row.expressno)"
              class="layui-btn layui-btn-primary layui-btn-sm"
              style="margin-left: 0;"
            >查看物流</a>
            <a
              v-if="scope.row.status==0"
              href="javascript:;"
              @click="goPay(scope.row.orderno)"
              class="layui-btn layui-btn-primary layui-btn-sm"
            >支付</a>
            <a
              v-if="scope.row.status==0"
              style="margin-top: 10px;"
              @click="closeOrder(scope.row.orderno)"
              href="javascript:;"
              class="layui-btn layui-btn-primary layui-btn-sm"
            >取消订单</a>
          </template>
        </el-table-column>-->
        <el-table-column prop="amount3" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              class="mb10"
              @click="orderdetail(scope.row.orderno)"
            >订单详情</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==2"
              type="primary"
              class="mb10"
              @click="confirmGoods(scope.row.orderno)"
            >确认收货</el-button>


            <el-button
              size="small"
              v-if="scope.row.expressno"
              type="primary"
              class="mb10"
              @click="logistics(scope.row.expressno)"
            >查看物流</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==0"
              type="primary"
              class="mb10"
              @click="goPay(scope.row.orderno)"
            >支付</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==0"
              type="primary"
              @click="closeOrder(scope.row.orderno)"
            >取消订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </section>
</template>
<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Order",
  data() {
    return {
      userInfo: {},
      guid: sessionStorage.guid,
      indexData: {},
      keyword: "",
      orderstatus: [
        { 0: "待付款" },
        { 1: "待发货" },
        { 2: "待收货" },
        { 3: "已完成" },
        { 4: "已取消" },
        { 5: "已退款" }
      ],
      page: 1,
      pagesize: 5,
      allOrder: {}, //全部订单的数据
      nowStatus: "",
      orderno: "",
      goodsKeyWord: ""
    };
  },
  watch: {
    orderno(newValue, oldValue) {
      // console.log("fskjfbvuidfbvuikji", newValue);
      // eventBus.$emit("my-event", newValue);
      eventBus.$emit("my-event", {
        orderno: newValue,
        orderType: 'jforder'
      });
    }
  },
  methods: {
    // 封装获取数据的方法
    async getOrderList() {
      let res = await this.$fetch("member/ordergiftlist", {
        body: {
          page: this.page,
          pagesize: this.pagesize,
          status: this.nowStatus,
          keyword: this.keyword
        }
      });
      for (let i = 0; i < res.data.length; i++) {
        let text = "";
        if (res.data[i].status == 0) {
          text = "待付款";
        } else if (res.data[i].status == 1) {
          text = "待发货";
        } else if (res.data[i].status == 2) {
          text = "已完成";
        } else if (res.data[i].status == 3) {
          text = "已取消";
        } else if (res.data[i].status == 4) {
          text = "已退款";
        }
        res.data[i]["statusText"] = text;
      }
      res.per_page = parseInt(res.per_page);
      this.allOrder = res;
      console.log("this.allOrder", this.allOrder);
    },
    currentPageorder(e) {
      this.page = e;
      this.getOrderList();
    },
    orderdetail(orderno) {
      console.log("orderno",orderno)
      this.orderno = orderno;
    },
    // 去支付
    goPay(orderno) {
      this.$router.push({ path: `/jieguo?orderno=${orderno}` });
    },
    // 取消订单
    async closeOrder(orderno) {
      let res = await this.$fetch("member/cancelorder", {
        body: { guid: this.guid, orderno }
      });
      if (res) {
        layer.alert("操作成功", { icon: 1 });
        this.getOrderList();
      }
    },

    // 确认收货
    async confirmGoods(orderno) {
      // let res = ajaxMethod("confirmGoods", { guid: this.guid, orderno });
      let res = await this.$fetch("member/confirmorder", {
        body: { guid: this.guid, orderno }
      });
      if (res) {
        layer.alert("操作成功", { icon: 1 });
        this.getOrderList();
      }
    },
    // 搜索
    search() {
      this.getOrderList();
    },
    // 改变tab
    changeTab(type) {
      this.nowStatus = type;
      this.getOrderList();
    },
    // 查看物流
    logistics(logistics) {
      console.log(logistics);
      layer.open({
        type: 2,
        title: "查看物流",
        shadeClose: true,
        shade: 0.8,
        area: ["400px", "90%"],
        content: `http://m.kuaidi100.com/index_all.html?type=&postid=${logistics}` //iframe的url
      });
    }
  },
  async mounted() {
    await this.getOrderList();
    // this.fenye();
  }
};
</script>
<style  lang='scss' scoped>
.layui-btn-sm {
  margin-left: 0;
}
.img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.cont {
  width: 150px;
  margin: 0 10px;
}
.cart-price {
  width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/jifenOrder.vue